"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const styles = () => ({
  root: {
    textTransform: 'unset',
    minWidth: 20,
    padding: '10px 0',
    marginLeft: 0,
    marginRight: 30,
    ' &:last-child': {
      margin: 0
    }
  },
  wrapper: {
    fontSize: _constants.fontSizes.subtitle1,
    fontWeight: 'bold',
    color: _constants.colours.black
  },
  textColorInherit: {
    opacity: 1
  }
});

const CustomTab = props => {
  return /*#__PURE__*/_react.default.createElement(_Tab.default, _extends({
    disableRipple: true
  }, props));
};

var _default = (0, _styles.withStyles)(styles)(CustomTab);

exports.default = _default;